<template>
<div id="station_page">
    <div id="main">
        <div class="main-wrap" v-on:scroll.passive="scollPos($event)">
            <div class="rec-wrap">
                <vertical-list-component ref="vertical" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import VerticalListComponent from '../component/VerticalListComponent';

import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';

export default {
    name: 'station_page',
    components: {
        'vertical-list-component': VerticalListComponent,
    },
    data() {
        return {
            params: {},
            scrollY: ''
        }
    },
    mounted() {
        this.$nextTick(function () {
            var getParams = common.getParams();
            var l_page = this.$store.getters['getLastPage'];
            if (l_page.value == "/detail") {
                setTimeout(function () {
                    var el_chk = document.getElementById('elem_' + getParams.elem_index);
                    if (el_chk != null) {
                        document.getElementById('elem_' + getParams.elem_index).scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }, 500);
            }
            if (getParams != null && getParams != 'undefined') {
                if (Object.keys(getParams).length !== 0) {
                    this.params = getParams;
                    this.initApp();
                }
            } else {
                this.params.area_code = '';
                this.params.subwayline = '';
                this.params.station_id = '';
                this.initApp();
            }

            EventBus.$on('station-search-data', (data) => {
                this.params = data;
                this.initApp();
            });
        });

    },
    created() {
        EventBus.$on('set_params_station', (data) => {
            data.scrollY = this.scrollY; // 스크롤 데이터

            common.setParams(data);
            EventBus.$emit('detail-data', data);
            this.$router.push('/detail');
        });
    },
    methods: {
        initApp() {
            common.setLocationData((data) => {
                data.type = config.REQ_SEARCH_STORE_LIST;
                data.search_type = 'station';
                data.area_code = this.params.area_code;
                data.subwayline = this.params.subwayline;
                data.station_id = this.params.station_id;
                this.$refs.vertical.initComponent(data);
            });
        },
        scollPos(e) {
            this.scrollY = e.target.scrollTop;
        },
    },
    beforeDestroy() {
        // 이벤트버스 사용 후 해제 시켜줄 것 그렇지 않으면 객체가 쌓이는 현상이 발생
        EventBus.$off('area-search-data');
        EventBus.$off('set_params_station');
        EventBus.$off('station-search-data');
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/StationPage.vue